export default __webpack_public_path__ + "static/media/placeholder_portfolio03-fr-web.6ddae4b3.png";